package ru.villawonka.app.resources.strings

class EnStringResources : StringResources {
    override val stubHttpError: String
        get() = "Failed to load data.\n" +
                "Please try again or come back later."

    override fun helloMessage(deeplink: String): String =
        "Hello! I saw your listing in the VillaWonka bot ($deeplink). Could you please let me know if it’s still available?"

    override val stubNoConnection: String
        get() = "No internet connection.\n" +
                "Please check your connection and try again."
    override val stubNotFound: String
        get() = "We couldn't find what you were looking for. The data may have been deleted or changed."
    override val stubRetryButton: String
        get() = "Refresh"
    override val conversationDetailsTitle: String
        get() = "Currency Conversion"
    override fun conversationDetailsDescription(
        originalCurrencyCode: String,
        displayCurrencyCode: String
    ): String = "Price converted from original currency ($originalCurrencyCode) to your selected currency ($displayCurrencyCode) at current exchange rate."
    override val conversationDetailsOriginalCost: String
        get() = "• Original price:"
    override val conversationDetailsExchangeRate: String
        get() = "• Exchange rate:"
    override val conversationDetailsExchangeRateDate: String
        get() = "• Exchange rate date:"
    override val conversationDetailsSummary: String
        get() = "• Total:"
    override val goToSource: String
        get() = "Go to source"
    override val badgeNew: String
        get() = "New"
    override val accommodationAdditionClosedKitchen: String
        get() = "Closed kitchen"
    override val accommodationAdditionVideoSurveillance: String
        get() = "Video surveillance"
    override val accommodationAdditionBarbecueArea: String
        get() = "Barbecue area"
    override val accommodationAdditionDrinkWaterIncluded: String
        get() = "Drinking water"
    override val accommodationAdditionHasDiscount: String
        get() = "Discount"
    override val rentTypeAnnually: String
        get() = "Annual"
    override val rentTypeDaily: String
        get() = "Daily"
    override val postCardRentCost: String
        get() = "Cost"
    override val postCardRentDeposit: String
        get() = "Deposit"
    override val postCardRentFrom: String
        get() = "Available from"
    override val postCardRentTo: String
        get() = "Available until"
    override val postCardDescriptionTab: String
        get() = "Description"
    override val postCardRentTab: String
        get() = "Rent"
    override val postCardAmenitiesTab: String
        get() = "Amenities"
    override val postCardMore: String
        get() = "More"
    override val postCardHide: String
        get() = "Hide"
    override val postCardSendMessage: String
        get() = "Send message"
    override val additionIncluded: String
        get() = "Included"
    override val additionNearby: String
        get() = "Nearby"
    override val additionAvailable: String
        get() = "Available"
    override val accommodationAdditionPool: String
        get() = "Pool"
    override val accommodationAdditionUtilityBillsIncluded: String
        get() = "Utility bills"
    override val accommodationAdditionNearGym: String
        get() = "Gym"
    override val accommodationAdditionNearCafe: String
        get() = "Cafe"
    override val accommodationAdditionParking: String
        get() = "Parking"
    override val accommodationAdditionWiFi: String
        get() = "Wi-Fi"
    override val accommodationAdditionCleaning: String
        get() = "Cleaning service"
    override val accommodationAdditionAirCondition: String
        get() = "Air conditioning"
    override val accommodationAdditionNearBeach: String
        get() = "Beach"
    override val accommodationAdditionClosedLivingRoom: String
        get() = "Ocean view"
    override val accommodationAdditionTerrace: String
        get() = "Terrace"
    override val accommodationAdditionJacuzzi: String
        get() = "Jacuzzi"
    override val accommodationAdditionWashingMachine: String
        get() = "Washing machine"
    override val accommodationAdditionTV: String
        get() = "TV"
    override val accommodationAdditionSafe: String
        get() = "Safe"
    override val rentType: String
        get() = "Rent"
    override val rentTypeMonthly: String
        get() = "Monthly"
    override val rentTypePeriod: String
        get() = "Period"
    override val accommodationType: String
        get() = "Accommodation"
    override val searchResultTitle: String
        get() = "Search results"
    override val countryIndonesia: String
        get() = "Indonesia"
    override val countryThailand: String
        get() = "Thailand"
    override val countryVietnam: String
        get() = "Vietnam"
    override val currencyRub: String
        get() = "Russian Ruble"
    override val currencyUsd: String
        get() = "US Dollar"
    override val currencyIdr: String
        get() = "Indonesian Rupiah"
    override val currencyThb: String
        get() = "Thai Baht"
    override val currencyVnd: String
        get() = "Vietnamese Dong"
    override val currencyCny: String
        get() = "Chinese Yuan"
    override val languageRussian: String
        get() = "Russian"
    override val languageEnglish: String
        get() = "English"
    override val languageRussianNative: String
        get() = "Русский"
    override val languageEnglishNative: String
        get() = "English"
    override val bottomNavSearch: String
        get() = "Search"
    override val bottomNavFavorites: String
        get() = "Favorites"
    override val tabBarItemProperty: String
        get() = "Property"
    override val tabBarItemTransport: String
        get() = "Transport"
    override val tabBarItemMoneyExchange: String
        get() = "Money exchange"
    override val tabBarItemVisaAgency: String
        get() = "Visa"
    override val tabBarSoonBadge: String
        get() = "Soon"
    override val topBarItemFilter: String
        get() = "Filter"
    override val topBarItemSort: String
        get() = "Sort by"
    override val searchFilterTopBarClear: String
        get() = "Clear"
    override val searchFilterTopBarClose: String
        get() = "Close"
    override val searchFilterTopBarTitle: String
        get() = "Filter"
    override val searchFilterBottomBarClear: String
        get() = "Clear"
    override val searchFilterBottomBarApply: String
        get() = "Apply"
    override val searchFilterLocationCityLabel: String
        get() = "City"
    override val searchFilterLocationCityPlaceholder: String
        get() = "Select the city"
    override val searchFilterLocationDistrictLabel: String
        get() = "District"
    override val searchFilterLocationDistrictPlaceholder: String
        get() = "Select the district"
    override val searchFilterPriceLabel: String
        get() = "Price"
    override val searchFilterCostMinPlaceholder: String
        get() = "from"
    override val searchFilterCostMaxPlaceholder: String
        get() = "to"
    override val accommodationTypeLabel: String
        get() = "Accommodation type"
    override val accommodationTypeVilla: String
        get() = "Villa"
    override val accommodationTypeAppartament: String
        get() = "Appartament"
    override val accommodationTypeGuesthouse: String
        get() = "Guest house"
    override val accommodationTypeRoom: String
        get() = "Room"
    override val searchFilterRoomsCountLabel: String
        get() = "Rooms count"
    override val searchFilterAmenitiesLabel: String
        get() = "Additions"
    override val favoritesTitle: String
        get() = "Favorites"
    override val favoritesLoadingLabel: String
        get() = "Loading your favorite listings..."
    override val favoritesEmptyLabel: String
        get() = "Your favorites are currently empty. Add listings you like here!"
    override val favoritesEmptyGoToSearchButton: String
        get() = "Go to Search"
    override val searchSortScreenTitle: String
        get() = "Sort by"
    override val searchSortScreenApply: String
        get() = "Apply"
    override val sortTypeNewest: String
        get() = "Newest"
    override val sortTypeHighPrice: String
        get() = "Price descending"
    override val sortTypeLowPrice: String
        get() = "Price ascending"
    override val searchResultEmptyLabel: String
        get() = "No results found for your request. Please try adjusting the filters."
    override val searchResultAdjustFiltersButton: String
        get() = "Adjust filters"
    override val searchResultLoadingLabel: String
        get() = "We use AI to thoroughly analyze and select the most valuable data to offer you what truly matters."
    override val setupTitle: String
        get() = "Preliminary Settings"
    override val setupSubtitle: String
        get() = "Let's customize the app for you"
    override val setupLanguageSelect: String
        get() = "Which language would you like to choose?"
    override val setupCountrySelect: String
        get() = "Search in which country?"
    override val setupCurrencySelect: String
        get() = "In which currency would you like to see prices?"
    override val setupCongratsTitle: String
        get() = "Congratulations, you have successfully set up the app"
    override val setupCongratsSubtitle: String
        get() = "We wish you a great experience with the app"
    override val setupContinueButton: String
        get() = "Continue"
    override val settingsTitle: String
        get() = "Settings"
    override val settingsLanguageItem: String
        get() = "Language"
    override val settingsCountryItem: String
        get() = "Country"
    override val settingsCurrencyItem: String
        get() = "Currency"
    override val settingsNewsItem: String
        get() = "Service News"
    override val settingsSupportItem: String
        get() = "Contact Support"
    override val settingsPrivacyPolicyItem: String
        get() = "Privacy Policy"
    override val settingsTermsOfUseItem: String
        get() = "Terms of Use"
    override val languagePickerTitle: String
        get() = "Language Selection"
    override val countryPickerTitle: String
        get() = "Country Selection"
    override val currencyPickerTitle: String
        get() = "Currency Selection"
}
